module.exports = __webpack_public_path__ + "img/Group656.89cd8e00.png";